export const WIZARD_DOCPILOT_COOKIE_KEY = 'storydoc_wizard_docpilot_DbGlmuVoG6';

// NOTE: this cookie is set by website directory astro project
export const WEBSITE_DIRECTORY_COOKIE_KEY = 'sd-anonymous-website-user-M7u8OPbtoBZ6oLgi2FtTu';